var map = {
	"./config.dev": 12978,
	"./config.dev.js": 12978,
	"./config.js": 57527,
	"./config.pg": 64800,
	"./config.pg.js": 64800,
	"./config.prod": 88212,
	"./config.prod.js": 88212,
	"./config.stg": 80265,
	"./config.stg.js": 80265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42574;